import PropTypes from 'prop-types';
import React from 'react';

import { WildlifeClass } from '~app/actions/wildlife';

const WildlifeSpeciesListHeaderCell = ({wildlifeClass}) => {
  return (
    <div className="WildlifeSpeciesListHeaderCell">
      <p className="WildlifeSpeciesListHeaderCell__title">
        {titleForWildlifeClass(wildlifeClass)}
      </p>
    </div>
  );
};

function titleForWildlifeClass(wildlifeClass) {
  let title = "";
  switch (wildlifeClass) {
    case WildlifeClass.amphibian:
      title = "Amphibians";
      break;
    case WildlifeClass.mammal:
      title = "Mammals";
      break;
    case WildlifeClass.reptile:
      title = "Reptiles";
      break;
    default:
      throw new Error(`Unexpected wildlife class: ${wildlifeClass}`);
  }
  return title;
}

WildlifeSpeciesListHeaderCell.propTypes = {
  wildlifeClass: PropTypes.number.isRequired,
};

export default WildlifeSpeciesListHeaderCell;



// WEBPACK FOOTER //
// ./src/components/WildlifeSpeciesListHeaderCell.js